import React from 'react';
import { Envelope, Xmark } from '@gravity-ui/icons';
import { Avatar } from '../Avatar';
import { Icon } from '../Icon';
import { block } from '../utils/cn';
import i18n from './i18n';
import './UserLabel.css';
const COMMON_AVATAR_PROPS = {
    size: 's',
};
const b = block('user-label');
export const UserLabel = React.forwardRef(({ type = 'person', avatar, children, view = 'outlined', onClick, onCloseClick, className, style, qa, }, ref) => {
    const clickable = Boolean(onClick);
    const closeable = Boolean(onCloseClick);
    const MainComponent = clickable ? 'button' : 'div';
    let avatarView = null;
    switch (type) {
        case 'email':
            avatarView = React.createElement(Avatar, Object.assign({ icon: Envelope }, COMMON_AVATAR_PROPS));
            break;
        case 'empty':
            avatarView = null;
            break;
        case 'person':
        default:
            if (!avatar && typeof children === 'string') {
                avatarView = React.createElement(Avatar, Object.assign({ text: children }, COMMON_AVATAR_PROPS));
            }
            else if (typeof avatar === 'string') {
                avatarView = React.createElement(Avatar, Object.assign({ imgUrl: avatar }, COMMON_AVATAR_PROPS));
            }
            else if (React.isValidElement(avatar)) {
                avatarView = avatar;
            }
            else if (avatar) {
                avatarView = React.createElement(Avatar, Object.assign({}, avatar, COMMON_AVATAR_PROPS));
            }
            break;
    }
    return (React.createElement("div", { className: b({
            view,
            empty: !avatarView,
            clickable,
            closeable,
        }, className), style: style, "data-qa": qa, ref: ref },
        React.createElement(MainComponent, { className: b('main'), type: clickable ? 'button' : undefined, onClick: onClick },
            avatarView ? React.createElement("div", { className: b('avatar') }, avatarView) : null,
            React.createElement("div", { className: b('text') }, children)),
        onCloseClick ? (React.createElement("button", { className: b('close'), type: "button", "aria-label": i18n('label_remove-button'), onClick: onCloseClick },
            React.createElement(Icon, { className: b('close-icon'), data: Xmark, size: 12 }))) : null));
});
UserLabel.displayName = 'UserLabel';
